module.exports = __webpack_public_path__ + "img/icon-chat.3370075a.svg";